import { expVal } from '@atlassian/jira-feature-experiments';

const JiraForYouLandAllNewUsersRelayProvider = {
	get(): boolean {
		return expVal('jira-for-you-land-all-new-users', 'isEnabled', false);
	},
};

export default JiraForYouLandAllNewUsersRelayProvider;
